"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "6", height: "10", viewBox: "0 0 6 10", className: "Icon chevron-left", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M5.067 8.183a.625.625 0 1 1-.884.884l-4-4a.625.625 0 0 1 0-.884l4-4a.625.625 0 0 1 .884.884L1.509 4.625l3.558 3.558z", fill: "#777", fillRule: "nonzero" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/chevron-left.js
// module id = 1788
// module chunks = 0